import { logger } from '../core/logger';
import { environment } from '../environments/environment';
import { loadScript } from './mfe-loader';
import '../types/__global';

let fraudInitPromise: Promise<void> | null = null;

export const initializeFraudBootstrap = (): Promise<void> => {
  if (fraudInitPromise) {
    return fraudInitPromise;
  }

  loadScript(environment.fraudBootstrapScriptUrl);

  const waitForFraudBootstrap = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      const timeoutMs = 10000;

      const checkInterval = setInterval(() => {
        if (globalThis.FRAUDBOOTSTRAP) {
          clearInterval(checkInterval);
          resolve();
        } else if (Date.now() - startTime >= timeoutMs) {
          clearInterval(checkInterval);
          reject(new Error('FraudBootstrap failed to load within timeout'));
        }
      }, 100);
    });
  };

  fraudInitPromise = waitForFraudBootstrap()
    .then(() => {
      globalThis.FRAUDBOOTSTRAP?.initializeFraudV2(environment.paymentsPanelApiUrl);
      logger.info('FraudBootstrap script loaded and initialized successfully');
    })
    .catch((error) => {
      logger.error('Error loading FraudBootstrap script:', error);
      throw error;
    });

  return fraudInitPromise;
};
